var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbtimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6036 18.0026C32.0057 18.0026 31.4182 18.0387 30.8409 18.116C24.1821 18.9097 18.8994 24.1873 18.1108 30.8461C18.0387 31.3615 18.0077 31.8872 18.0026 32.418V32.7943C17.9974 32.7324 17.9974 32.6654 17.9974 32.6036C17.9974 32.0057 17.9613 31.4182 17.884 30.8409C17.0903 24.1821 11.8127 18.9097 5.15906 18.116C4.58182 18.0387 3.99427 18.0026 3.39642 18.0026C3.99427 18.0026 4.58182 17.9665 5.15906 17.8892C11.8179 17.0955 17.3171 11.8385 17.884 5.15906C17.9407 4.48905 17.9871 3.14903 18.0026 2.47903C18.018 1.86056 18.0026 0 18.0026 0C17.8686 0 17.7294 0 17.5954 0.0051539C7.98855 0.216464 0.216464 7.9937 0.0051539 17.6006C0 17.7346 0 17.8686 0 18.0026C0 18.1366 0 18.2706 0.0051539 18.4046C0.216464 28.0063 7.98855 35.7835 17.5954 35.9948C17.7294 36 17.8686 36 18.0026 36C18.1366 36 18.2654 36 18.3994 35.9948C28.0063 35.7887 35.7835 28.0115 35.9948 18.4046C36 18.2706 36 18.1366 36 18.0026H32.6036Z",
    fill: "#00DF67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 32.418C17.9974 32.4799 17.9974 32.5417 17.9974 32.6036C17.9974 32.6654 17.9974 32.7324 18.0026 32.7943V32.418Z",
    fill: "#00DF67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7588 14.4825C32.758 14.4825 36 11.2405 36 7.24123C36 3.24201 32.758 0 28.7588 0C24.7595 0 21.5175 3.24201 21.5175 7.24123C21.5175 11.2405 24.7595 14.4825 28.7588 14.4825Z",
    fill: "#00DF67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbtimg);
export default __webpack_public_path__ + "static/media/abtimg.2af6ef1d52b0ce1180a9711d33515a27.svg";
export { ForwardRef as ReactComponent };